import type {ParsedStyleItem, Property} from '../types'

function migrateWixMediaBackground(property: Property): Property {
    const propertyValue: string = property.value
    if (/^wixMediaUrl\([^)]+\)/.test(propertyValue.trim())) {
        return property
    }

    const wixMediaUrlMatch = propertyValue.match(/wixMediaUrl\([^)]+\)/)
    if (!wixMediaUrlMatch) {
        return property // return original property if no match found
    }

    const wixMediaUrl: string = wixMediaUrlMatch[0]
    const remainingParts: string[] = propertyValue.replace(wixMediaUrl, '').trim().split(' ')

    if (remainingParts.length !== 7 && remainingParts.length !== 8) return property
    const position: string = remainingParts[3]
    const size: string = remainingParts[5]
    const repeat: string = remainingParts[0]
    const addedLowerLayer = ', rgba(255,255,255,1)'

    const output: string = `${wixMediaUrl} ${position} ${position} / ${size} ${repeat}${addedLowerLayer}`

    return {...property, value: output}
}
function processProperties<T>(properties: T[], updateFunction: (property: T) => T): T[] {
    return properties.map(property => {
        if ((property as any).cssProp === 'background') {
            return updateFunction(property)
        }
        return property
    })
}

function migrateBackground(styleItems: ParsedStyleItem[]): ParsedStyleItem[] {
    return styleItems.map(styleItem => {
        const {parsedStyle} = styleItem
        const updatedParsedStyle = Object.entries(parsedStyle).reduce(
            (acc, [selector, {properties, mobileProperties}]) => {
                const updatedProperties = processProperties(properties, migrateWixMediaBackground)
                const updatedMobileProperties = processProperties(mobileProperties, migrateWixMediaBackground)
                return {
                    ...acc,
                    [selector]: {
                        ...acc[selector],
                        properties: updatedProperties,
                        mobileProperties: updatedMobileProperties
                    }
                }
            },
            parsedStyle
        )

        return {
            ...styleItem,
            parsedStyle: updatedParsedStyle
        }
    })
}

export default migrateBackground
